module.exports = __webpack_public_path__ + "img/inspect_3.ec197d81.png";